import { createFileRoute } from "@tanstack/react-router";
import { LexiconPage, lexiconHead } from "@/components/LexiconPage";

export const Route = createFileRoute("/glossary/$")({
  head: () => lexiconHead("en", { variant: "unknown" }),
  component: () => <LexiconPage lang="en" />,
});
